import type { ComponentType } from 'react'

import type { GamificationPageBlock } from '@/types/gamificationPageBlock'

import { MedalsPreview } from '../components/MedalsPreview'
import { ObjectivesCard } from '../components/ObjectivesCard'
import { RankingPreview } from '../components/RankingPreview'
import {
  BannerBlock,
  CtaBlock,
  EmbedBlock,
  RichTextBlock,
  SectionTitleBlock
} from './custom/CustomBlocks'
import { MissionsBlock } from './system/MissionsBlock'
import { MatchmakingBlock } from './system/MatchmakingBlock'
import { PartnersBlock } from './system/PartnersBlock'
import { QuestBookBlock } from './system/QuestBookBlock'
import { ScheduleBlock } from './system/ScheduleBlock'
import { SocialFeedBlock } from './system/SocialFeedBlock'
import { StoreBlock } from './system/StoreBlock'

export interface BlockComponentProps {
  block: GamificationPageBlock
}

/**
 * `kind` → componente. `kind` sem entrada aqui é ignorado silenciosamente pelo
 * renderer: a api pode servir um bloco que esta versão do app ainda não sabe
 * desenhar, e isso não pode derrubar o resto da home.
 */
export const BLOCK_COMPONENTS: Partial<
  Record<GamificationPageBlock['kind'], ComponentType<BlockComponentProps>>
> = {
  quest_book: QuestBookBlock,
  objectives: ObjectivesCard,
  ranking: RankingPreview,
  medals: MedalsPreview,
  missions: MissionsBlock,
  schedule: ScheduleBlock,
  social_feed: SocialFeedBlock,
  partners: PartnersBlock,
  matchmaking: MatchmakingBlock,
  shop: StoreBlock,

  banner: BannerBlock,
  rich_text: RichTextBlock,
  embed: EmbedBlock,
  cta: CtaBlock,
  section_title: SectionTitleBlock
}

export const getBlockComponent = (
  kind: GamificationPageBlock['kind']
): ComponentType<BlockComponentProps> | null => BLOCK_COMPONENTS[kind] ?? null
